import './App.css';
import React from 'react';
import ResumeForm from './Components/ResumeForm';

function App() {
	return (
		<div className='bg-gray-500 h-screen w-screen flex justify-center items-center'>
			<ResumeForm />
		</div>
	);
}

export default App;
